import { Avatar, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import user2Src from "./user2.jpg";

export default () => (
	<CssColumnGrid columns={2}>
		<Text semiBold text="image" />
		<Text semiBold text="no image" />
		<Avatar external src={user2Src} />
		<Avatar external initials="CS" />
	</CssColumnGrid>
);